export default __webpack_public_path__ + "static/media/wen-moon.bf2ad36f.jpeg";